var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HD",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 16.36,
    viewBox: "0 0 30 16.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25507",
    "data-name": "Path 25507",
    d: "M790.27.63a1.941,1.941,0,0,1,2.192,1.977V13.753a1.941,1.941,0,0,1-2.192,1.977H766.05a1.941,1.941,0,0,1-2.192-1.977V2.607A1.941,1.941,0,0,1,766.05.63Zm0-.63H766.05a2.6,2.6,0,0,0-2.89,2.607V13.753a2.6,2.6,0,0,0,2.89,2.607H790.27a2.6,2.6,0,0,0,2.89-2.607V2.607A2.6,2.6,0,0,0,790.27,0",
    transform: "translate(-763.16)",
    fill: "#220046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25528",
    "data-name": "Path 25528",
    d: "M-1.693.78H.157V-6.41H-1.693V-3.8H-4.464V-6.41H-6.315V.78h1.851V-2.058h2.771Zm3.2,0H4.117C6.462.78,8.189-.734,8.189-2.8c0-2.086-1.727-3.612-4.072-3.612H1.5Zm2.58-5.452A1.884,1.884,0,0,1,6.2-2.82,1.882,1.882,0,0,1,4.095-.958H3.41V-4.671Z",
    transform: "translate(14.317 11.01)",
    fill: "#6b00dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdIcon);
export default __webpack_public_path__ + "static/media/hd-icon.20da57a0f5db77d8758b9ae953900632.svg";
export { ForwardRef as ReactComponent };